<template>
<div class="edit-block">
<block-edit placeholder="Insert intro text here" class="intro" :isNew="false" :value="value" v-on:input="$emit('input', $event)" v-on:new-block="$emit('new-block', $event)" v-on:new-init-done="block.new=false" />
<a class="drag"></a>
<a class="remove" v-on:click="$emit('remove')"></a>
</div>
</template>

<script>
export default {
  props: ["value", "block"],
}
</script>
